import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';

const getUploadFileModalContent = () => {
    const localizedStrings = getLocalizedStrings();

    const title = [localizedStrings[localizationKeys.BUILDING_PROFILE_PAGE_UPLOAD_FILE_TITLE]];

    const submitButton = [localizedStrings[localizationKeys.SETTINGS_ROOM_TYPE_ADD_FORM_SUBMIT_BUTTON]];

    const cancelButton = [localizedStrings[localizationKeys.SETTINGS_ROOM_TYPE_ADD_FORM_CANCEL_BUTTON]];

    return {
        title,
        submitButton,
        cancelButton,
    };
};

export default {getUploadFileModalContent};
